export enum UserRoleType {
    Admin = "Admin",
    UserManager = "UserManager"
}